export default "__VITE_ASSET__BRqNrHHE__"